export function parseDate(date: any, showTime: boolean, isUTC: boolean) {
    if (!date) {
        return ''
    }

    const dateString = String(date).trim()
    const isDateOnly = /^\d{4}-\d{2}-\d{2}$/.test(dateString)

    let parsedDate: Date

    if (isDateOnly && !isUTC) {
        const [year, month, day] = dateString.split('-').map(Number)
        parsedDate = new Date(year, month - 1, day)
    } else if (isUTC) {
        const hasTimezoneInfo = /[zZ]|[-+]\d{2}:?\d{2}$/.test(dateString)
        const normalizedDate = dateString.includes('T') ? dateString : dateString.replace(' ', 'T')
        parsedDate = new Date(hasTimezoneInfo ? normalizedDate : `${normalizedDate}Z`)
    } else {
        parsedDate = new Date(dateString)
    }

    if (Number.isNaN(parsedDate.getTime())) {
        return ''
    }

    if (showTime) {
        return `${parsedDate.toLocaleDateString('pt-BR')} às ${parsedDate.toLocaleTimeString('pt-BR')}`
    }

    return parsedDate.toLocaleDateString('pt-BR')
}
